import { type MapContent, type MapCountry } from '../types'

type CmsMapCountry = Omit<MapCountry, 'subjects' | 'cases'> &
  Partial<Pick<MapCountry, 'subjects' | 'cases'>>
export type CmsMapContent = Omit<MapContent, 'countries'> & { countries: CmsMapCountry[] }

export const normalizeMapContent = (content: CmsMapContent): MapContent => ({
  ...content,
  countries: content.countries.map((country) => ({
    ...country,
    subjects: Array.isArray(country.subjects) ? country.subjects : [],
    cases: Array.isArray(country.cases) ? country.cases : [],
  })),
})
